var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"App"}},[(_vm.getLoadingScreen)?[_c('CoreLoadingScreen')]:[(_vm.isLogged)?[_c('CoreAppBar'),_c('CoreDrawer'),_c('CoreView')]:[_c('router-view')],_c('Loading'),_c('Alert')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }